import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { useBankPositionsColumns } from "./columns";
import { client, table_name, type BankPositionRow, type FilterSchema } from "./config";
import { FilterBankPositions } from "./filter";

export function BankPositionsTable() {
  const { t } = useTranslation("tables");
  const columns = useBankPositionsColumns();
  const resourceLabel = t(`${table_name}.title`, { defaultValue: "Bank Positions" });
  const { selectionActions, modal } = useBulkDeleteControls<BankPositionRow>({
    client,
    table_name,
    resourceLabel,
  });

  return (
    <>
      <Table<BankPositionRow, FilterSchema>
        label={resourceLabel}
        client={client}
        table_name={table_name}
        columns={columns}
        filter={<FilterBankPositions />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
}
